import { Catalog } from "../components/Catalog";

export default function Parfums() {
  return (
    <main>
      <Catalog />
    </main>
  );
}
